import React from 'react';
import { Prompt } from 'react-router-dom';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Button from '../../../../components/atomic/Buttons/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Icon from '@material-ui/core/Icon';
import FileUploader from '../../../../components/atomic/Inputs/FileUploader';
import VideoSelect from '../../../../components/molecule/FormFields/VideoSelect';
import { AlertModal } from '../../../../components/molecule/Modals/AlertModal';
import * as apiServices from '../../../../services/apiServices';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { startPolling } from '../../../../modules/UploadQueue';
import { toast } from 'react-toastify';
import {
  ACCEPTED_VIDEO_FORMATS,
  STREAMING_STATUS,
} from '../../../../core/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
const StretchContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${'' /* min-width: 200px;
  max-width: 200px;
  height: 100%; */}
  // background: rgba(0,0,0,0.1);
  flex: 1;
  margin: 3px;
  overflow: hidden;
`

const ItemContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 200px;
  // width: 50%;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
`
const OptionWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  height: 100%;
`
const OptionSelect = styled.div`
  direction: rtl;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const UploadButtonContainer = styled.div`
  // margin: 3px;
`
const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
  height: 150px;
`
const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`
const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

class BioMediaForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      videoUploadProgress: 0,
    }
  }

  componentDidUpdate(prevProps) {
    const { bioVideo: prevBioVideo } = prevProps.uploadQueueState;
    const { uploadQueueState: { bioVideo }, values } = this.props;

    if (prevBioVideo && bioVideo &&
        prevBioVideo[values.user_id] && bioVideo[values.user_id] &&
        prevBioVideo[values.user_id].streaming_status === STREAMING_STATUS.PROCESSING &&
        bioVideo[values.user_id].streaming_status === STREAMING_STATUS.COMPLETE) {

      this.changeTracker({
        id: bioVideo[values.user_id].videoId,
        source_video: bioVideo[values.user_id].video,
        streaming_status: bioVideo[values.user_id].streaming_status,
        thumbnail: bioVideo[values.user_id].thumbnail,
        url: bioVideo[values.user_id].streaming_video,
      }, 'video');
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  manualSubmit = () => {
    const { submitExerciseForm } = this.props;
    submitExerciseForm();
  }

  removeVideo = () => this.changeTracker(null,'video')

  videoUploadFinished = ({ awsUrl }) => {
    const { startPolling, values } = this.props;

    apiServices.addOverviewVideo({
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
    }).then(data => {
      toast.success('video uploaded successfully');
      this.setState({ videoUploadProgress: 0 });
      startPolling({
        id: values.user_id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'bioVideo'
      });
    });
  }
  updateVideoUploadProgress = (videoUploadProgress) => {
    this.setState({ videoUploadProgress });
  }

  render () {
    const {
      authState: { userData },
      values,
      onClickCancel,
      dirty,
      uploadQueueState: { bioVideo },
    } = this.props

    const { videoUploadProgress } = this.state;

    return (
      <FormStyled>
        <Container>
          <StretchContainer>
            <VideoContainer>
              <ItemContainer>
                <OptionWrapper>
                  <OptionSelect>
                    {
                      values.video ? (
                        <VideoSelectStyled
                          onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', this.removeVideo)}
                          processing={(bioVideo[values.user_id] && bioVideo[values.user_id].streaming_status === STREAMING_STATUS.PROCESSING)}
                          thumbnail={values.video.thumbnail}
                          video={values.video.url}
                        />
                      ) : (
                        <ImageWrapper style={{opacity: 0.3}}>
                          <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                          No Video
                          {
                            bioVideo[values.user_id] && bioVideo[values.user_id].streaming_status === STREAMING_STATUS.PROCESSING &&
                              <CircularProgress />
                          }
                        </ImageWrapper>
                      )
                    }
                  </OptionSelect>
                </OptionWrapper>
                <UploadButtonContainer>
                  <FileUploader
                    accept={ACCEPTED_VIDEO_FORMATS}
                    buttonText="Upload Bio Video"
                    fileType="video"
                    fullWidth
                    metadata={{ trainer_id: userData.user_id.toString() }}
                    onFinish={this.videoUploadFinished}
                    onProgress={this.updateVideoUploadProgress}
                    variant='contained'
                  />
                </UploadButtonContainer>
                { videoUploadProgress > 0 && (
                  <UploadProgressContainer>
                    <LinearProgress variant="determinate" value={videoUploadProgress} />
                  </UploadProgressContainer>
                )}
              </ItemContainer>
            </VideoContainer>
          </StretchContainer>
        </Container>
        <ButtonContainer>
          <ButtonStyled disabled={!dirty} type="submit" color="primary" variant="contained">Save</ButtonStyled>
          <ButtonStyled onClick={onClickCancel} color="secondary" variant="contained">Cancel</ButtonStyled>
        </ButtonContainer>
        <Prompt when={dirty} message={`You have unsaved changes. Are you sure you want to leave?`}/>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    uploadQueueState: state.uploadQueueState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    startPolling: startPolling,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
    last: yup.string(),
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
}))(BioMediaForm);
